<h2 mat-dialog-title class="dialog-title">
  <mat-icon>terminal</mat-icon>
  <span>Contract Logs</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="loadLogs()" matTooltip="Refresh">
    <mat-icon>refresh</mat-icon>
  </button>
  <button mat-icon-button (click)="toggleAutoScroll()" [matTooltip]="autoScroll ? 'Auto-scroll on' : 'Auto-scroll off'">
    <mat-icon>{{ autoScroll ? 'vertical_align_bottom' : 'format_align_justify' }}</mat-icon>
  </button>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Loading logs...</p>
    </div>
  } @else if (lines.length === 0) {
    <div class="empty-state">No logs found for this contract.</div>
  } @else {
    <div class="log-container" #logContainer (scroll)="onScroll()">
      @for (line of lines; track $index) {
        <div class="log-line" [class]="line.cssClass">
          @if (line.timestamp) {
            <span class="log-timestamp">{{ line.timestamp }}</span>
            <span class="log-source">[{{ line.source }}]</span>
            <span class="log-level">[{{ line.level }}]</span>
          }
          <span class="log-message">{{ line.message }}</span>
        </div>
      }
    </div>
    <div class="log-footer">
      <span>{{ lines.length }} lines</span>
      @if (!autoScroll) {
        <span class="scroll-hint" (click)="toggleAutoScroll()">
          <mat-icon>arrow_downward</mat-icon> Jump to bottom
        </span>
      }
    </div>
  }
</mat-dialog-content>
